import React from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';

const View = ({ show, onClose, data }) => {

  const appointment_category = [
        { value: 1, label: "Walk-in" },
        { value: 2, label: "Online" },
        { value: 3, label: "Ofline" },
        { value: 4, label: "Video" },
        { value: 5, label: "Payment" }
  ];

  // format date display
  const formatDate = (date) => {
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, '0');
      const month = months[d.getMonth()];
      const year = d.getFullYear();
      return `${day}-${month}-${year}`;
  };

  function convert24to12(time24) {
      if (time24) {
          const [hourStr, minute, second] = time24.split(':');
          let hour = parseInt(hourStr, 10);

          // Determine AM or PM
          const ampm = hour >= 12 ? 'PM' : 'AM';

          // Convert hour from 24-hour to 12-hour format
          hour = hour % 12;
          if (hour === 0) hour = 12; // the hour '0' should be '12'

          // Return formatted string without seconds (optional)
          return `${hour}:${minute} ${ampm}`;
      } else {
          return '';
      }
  };

  return (
    <Modal show={show} size="md">
      <div className="modal-content border border-red rounded-xxl">
        <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
          <div className='d-flex align-items-center gap-3 flex-wrap'>
            <h3 className="modal-title text-white">View Lead</h3>
            <div className="ms-1 me-1 fw-bold text-white">-</div>
            <Badge bg="none" className='py-1 px-2 fs-4 border border-white shadow-lg text-white'>{data.lead_status_name}</Badge>
          </div>
          <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
            <span className="text-white">×</span>
          </Button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
              <label className='text-gray-800 font-w500 fs-7'>Lead</label>
              <label className='text-black fs-6 font-w500'>{data.lead_name}</label>
            </div>
            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
              <label className='text-gray-800 font-w500 fs-7'>Mobile No</label>
              <label className='text-black fs-6 font-w500'>{data.lead_mobile}</label>
            </div>
            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
              <label className='text-gray-800 font-w500 fs-7'>Appointment Category</label>
              <label className='text-black fs-6 font-w500 text-break'>{appointment_category.find(catego => catego.value == data.appointment_category).label}</label>
            </div>
            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
              <label className='text-gray-800 font-w500 fs-7'>Appointment Date</label>
              <label className='text-black fs-6 font-w500'>{formatDate(data.appointment_date)} {convert24to12(data.appointment_time)}</label>
            </div>
            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
              <label className='text-gray-800 font-w500 fs-7'>Assigned Staff</label>
              <label className='text-black fs-6 font-w500'>{data.staff_name}</label>
            </div>
            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
              <label className='text-gray-800 font-w500 fs-7'>Appointment Reason</label>
              <label className='text-black fs-6 font-w500'>{data.appointment_reason}</label>
            </div>
          </div>
          <div class="row mb-2">
            <label class="col-12 text-gray-800 font-w500 fs-7">Description </label>
            <label class="col-12 text-black fs-6 font-w500">&emsp;&emsp; {data.description ? data.description : '-'}</label>
          </div>
        </div>
      </div>
    </Modal >
  );
};

export default View;
